import { createSlice } from "@reduxjs/toolkit";
import { ActivityAdvice } from "domain/entities/activities.entities";
import { Technique } from "domain/entities/techniques.entities";
import {
  getTechniques,
  getTechnique,
  getTechniqueAdvice,
  getFavoritesTechniques,
  getPauses,
  setIsTechniqueLoading,
  createTechnique,
  updateSequences,
  getRandomTechnique,
} from "domain/techniques/techniques.actions";

export type TechniquesState = {
  isTechniquesLoading: boolean;
  techniques: Technique[];
  isTechniqueLoading: boolean;
  technique: Technique;
  advice: ActivityAdvice | null;
  pauses: Technique[];
  totalCount: number;
  randomTechnique: Technique | null;
};

const initialState: TechniquesState = {
  isTechniquesLoading: false,
  techniques: [],
  isTechniqueLoading: false,
  technique: null,
  advice: null,
  pauses: [],
  totalCount: 0,
  randomTechnique: null,
};

export const techniquesSlice = createSlice({
  name: "techniques",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //GET TECHNIQUES
    builder.addCase(getTechniques.fulfilled, (state, action) => {
      state.techniques = action.payload.techniques;
      state.totalCount = action.payload.totalCount;
      state.isTechniquesLoading = false;
    });
    builder.addCase(getTechniques.pending, (state, action) => {
      state.isTechniquesLoading = true;
    });
    //GET TECHNIQUE
    builder.addCase(getTechnique.fulfilled, (state, action) => {
      state.technique = action.payload.technique;
      state.isTechniqueLoading = false;
    });
    builder.addCase(getTechnique.pending, (state, action) => {
      state.isTechniqueLoading = true;
    });
    //GET ADVICE
    builder.addCase(getTechniqueAdvice.fulfilled, (state, action) => {
      state.advice = action.payload.advice;
      state.isTechniqueLoading = false;
    });
    builder.addCase(getTechniqueAdvice.pending, (state, action) => {
      state.isTechniqueLoading = true;
    });
    //GET FAVORITES TECHNIQUES
    builder.addCase(getFavoritesTechniques.fulfilled, (state, action) => {
      state.techniques = action.payload.techniques;
      state.isTechniquesLoading = false;
    });
    builder.addCase(getFavoritesTechniques.pending, (state, action) => {
      state.isTechniquesLoading = true;
    });
    //GET PAUSES
    builder.addCase(getPauses.fulfilled, (state, action) => {
      state.pauses = action.payload.techniques;
      state.isTechniqueLoading = false;
    });
    builder.addCase(getPauses.pending, (state, action) => {
      state.isTechniqueLoading = true;
    });
    //SET IS TECHNIQUE LOADING
    builder.addCase(setIsTechniqueLoading.fulfilled, (state, action) => {
      state.isTechniqueLoading = action.payload.isLoading;
    });
    //CREATE TECHNIQUE
    builder.addCase(createTechnique.fulfilled, (state, action) => {
      state.isTechniquesLoading = false;
    });
    builder.addCase(createTechnique.pending, (state, action) => {
      state.isTechniquesLoading = true;
    });
    //UPDATE SEQUENCES
    builder.addCase(updateSequences.fulfilled, (state, action) => {
      state.isTechniquesLoading = false;
    });
    builder.addCase(updateSequences.pending, (state, action) => {
      state.isTechniquesLoading = true;
    });
    //GET RANDOM TECHNIQUE
    builder.addCase(getRandomTechnique.fulfilled, (state, action) => {
      state.randomTechnique = action.payload.technique;
      state.isTechniqueLoading = false;
    });
    builder.addCase(getRandomTechnique.pending, (state, action) => {
      state.isTechniqueLoading = true;
    });
  },
});
